import React from 'react';
import dayjs from 'dayjs';

//Estilos
import './NewDJCE.css';

function NewDJCE({ functions, states }) {
    const { user, masters, DJCEData, DJCECerrada } = states;

    const {
        handleSubmit,
        formState: { errors },
        onSubmit,
        setOpenFirmaModal,
        setOpenVistoModal,
        setOpenInhabilitarModal,
    } = functions;

    const Titulares = DJCEData?.declaracion?.titulares?.split('/');

    return (
        <div className="newDJCE-container">
            <form className="newDJCE-form" onSubmit={handleSubmit(onSubmit)}>
                <h4>
                    {`Declaración Jurada de Cosecha Efectiva ${DJCEData?.declaracion?.serie}-P-${DJCEData?.declaracion?.numero} para viñedo ${DJCEData?.declaracion?.viniedo}`}
                </h4>
                {Titulares?.map((t, i) => {
                    return (
                        <div key={i} className="newDJCE-titular_container">
                            <label className="newDJCE-label">
                                <span>Titular: </span>
                                <p>{t}</p>
                            </label>
                            <label className="newDJCE-label">
                                <div>
                                    <span>Nro de Documento / RUT: </span>
                                    <p>
                                        {
                                            DJCEData?.declaracion
                                                .titulares_Documento[i]
                                        }
                                    </p>
                                    {/* <input
                                        className="signup-input"
                                        type="number"
                                        {...register(
                                            `DJCEData?.declaracion.titulares_Documento[${i}]`,
                                            {
                                                required:
                                                    'Debe ingresar un documento de identidad',
                                                validate: {
                                                    minLength: (v) =>
                                                        v.length >= 8 ||
                                                        'El número de documento debe tener un mínimo de 8 caracteres',
                                                },
                                            }
                                        )}
                                        onKeyPress={(e) => {
                                            if (
                                                !/[A-Za-z0-9]+/.test(e.key) ||
                                                e.target.value.length > 15
                                            ) {
                                                e.preventDefault();
                                            }
                                        }}
                                    /> */}
                                </div>
                                {errors.DJCEData?.declaracion
                                    ?.titulares_Documento[i] && (
                                    <small className="form__error">
                                        {
                                            errors.DJCEData?.declaracion
                                                ?.titulares_Documento[i]
                                                ?.message
                                        }
                                    </small>
                                )}
                            </label>
                        </div>
                    );
                })}
                <section className="DJCE-info-section">
                    <label className="DJCE-label">
                        <span>Habilitada: </span>
                        <p>
                            {masters.HabilitationTypes?.find(
                                (ht) =>
                                    ht.id === DJCEData?.declaracion?.habilitada
                            )?.nombre.replace('_', ' ')}
                        </p>
                    </label>
                    <label className="DJCE-label">
                        <span>Fecha: </span>
                        <p>
                            {dayjs(DJCEData?.declaracion?.fecha).format(
                                'DD-MM-YYYY'
                            )}
                        </p>
                    </label>
                    <label className="DJCE-label">
                        <span>Padrones: </span>
                        <p>
                            {DJCEData?.declaracion?.padrones.replace('_', ', ')}
                        </p>
                    </label>
                    <label className="DJCE-label">
                        <span>Timbre: </span>
                        <p>
                            {DJCEData?.declaracion?.timbre ? 'PAGO' : 'NO PAGO'}
                        </p>
                    </label>
                    <label className="DJCE-label">
                        <span>Viñedo: </span>
                        <p>{DJCEData?.declaracion?.viniedo}</p>
                    </label>
                    <label className="DJCE-label">
                        <span>Teléfono: </span>
                        <p>{DJCEData?.declaracion?.telefono}</p>
                    </label>
                    <label className="DJCE-label">
                        <span>Razón Social: </span>
                        <p>{DJCEData?.declaracion?.razon_social}</p>
                    </label>
                    <label className="DJCE-label">
                        <span>Ubicación: </span>
                        <p>
                            X: {parseInt(DJCEData?.declaracion?.ubicacion_X)},
                            Y: {parseInt(DJCEData?.declaracion?.ubicacion_Y)}
                        </p>
                    </label>
                    <label className="DJCE-label">
                        <span>Departamento: </span>
                        <p>{DJCEData?.declaracion?.departamento}</p>
                    </label>
                    <label className="DJCE-label">
                        <span>Superficie: </span>
                        <p>{DJCEData?.declaracion?.total_Superficie} m²</p>
                    </label>
                    {/* <label className="DJCE-label">
                                    <span>Responsable: </span>
                                    <p>
                                        {nombre} {apellido} ({usuario})
                                    </p>
                                </label> */}
                </section>
                <h4 className="DJCE-title">Guías Utilizadas</h4>
                <section className="DJCE-info-section">
                    <table>
                        <thead>
                            <tr>
                                <th>Destino</th>
                                <th>Comprador</th>
                                <th>Nro Inscripción del Comprador</th>
                                <th>Nro Guía</th>
                                <th>Variedad</th>
                                <th>Kilos</th>
                                <th>Grado Glucosa</th>
                                <th>Precio por Kg</th>
                            </tr>
                        </thead>
                        <tbody>
                            {DJCEData?.djceGuias?.map((dg, i) => {
                                return (
                                    <tr key={i}>
                                        <td>
                                            {masters?.Destinos?.find(
                                                (d) => d.id === dg.destino
                                            )?.nombre.replaceAll('_', ' ')}
                                        </td>
                                        <td>{dg.comprador}</td>
                                        <td>{dg.nro_Inscripcion}</td>
                                        <td>{dg.guiaNum}</td>
                                        <td>{dg.variedad}</td>
                                        <td>{dg.kilos} kg</td>
                                        <td>{dg.grado_Gluc}</td>
                                        <td>{dg.precio_Kg}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </section>
                <h4 className="DJCE-title">Producción de Uva</h4>
                <section className="DJCE-info-section">
                    <table>
                        <thead>
                            <tr>
                                <th>Variedad</th>
                                <th>Superficie</th>
                                <th>Kilos Ingresados</th>
                            </tr>
                        </thead>
                        <tbody>
                            {DJCEData?.djceUvas?.map((it, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{it.variedad}</td>
                                        <td>{it.superficie} m²</td>
                                        <td>{it.kilos} kg</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </section>
                <footer className="DJCE-footer">
                    <label>
                        <span>Total Kilos de Producción: </span>
                        <p>{DJCEData?.declaracion?.total_Kilos} kg</p>
                    </label>
                </footer>
                <div className="newDJCE-footer">
                    {user.tipo !== 3 && (
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => setOpenFirmaModal(true)}
                            disabled={DJCECerrada}
                        >
                            Firmar
                        </button>
                    )}
                    {user.tipo === 3 && (
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => setOpenVistoModal(true)}
                        >
                            Vista
                        </button>
                    )}
                    {user.tipo === 3 && (
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => setOpenInhabilitarModal(true)}
                        >
                            Inhabilitar
                        </button>
                    )}
                </div>
            </form>
        </div>
    );
}

export default NewDJCE;
